"use client"

import { useCallback } from "react"
import { useSnapshot } from "valtio"
import { PreviousAccountsState } from "../../stores/previousAccountsStore"

export function usePreviouslyConnectedAccounts() {
  const accounts = useSnapshot(PreviousAccountsState.accounts)
  return accounts
}

export function useGetPreviouslyConnectedAccountsForConnector() {
  const previouslyConnectedAccounts = usePreviouslyConnectedAccounts()
  const getPreviouslyConnectedAccountsForConnector = useCallback(
    (connectorId: string) => {
      return previouslyConnectedAccounts.filter(
        account => account.connectorId === connectorId,
      )
    },
    [previouslyConnectedAccounts],
  )
  return getPreviouslyConnectedAccountsForConnector
}
